var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "highlighted-result" }, [
    _c("span", {
      staticClass: "highlighted-result__title",
      domProps: { textContent: _vm._s(_vm.resource.label) },
    }),
    _vm._v(" "),
    _c("span", {
      staticClass: "highlighted-result__content",
      domProps: { innerHTML: _vm._s(_vm.resource.snippet) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }